import { Ability, AbilityBuilder } from '@casl/ability'
import { createContext } from 'react'
import { loginAbilities } from './abilities/loginAbilities'
import { subAdminAbilities } from './abilities/subAdminAbilities'
import { adminAbilities } from './abilities/adminAbilities'
import { userAbilities } from './abilities/userAbilities'
import { clubAbilities } from './abilities/clubAbilities'
import { commonAbilities } from './abilities/commonAbilities'

export type Actions = 'MANAGE' | 'VIEW' | 'ADD' | 'EDIT' | 'DELETE' | 'UPDATE'
export type Subjects = 'ALL' | 'HOME' | 'USER' | 'CLUB' | 'CLUB_TABLE' | 'TOURNAMENT'

export type AppAbility = Ability<[Actions, Subjects]>

export const defineAbilityFor = (role?: string): AppAbility => {
  const { can, rules } = new AbilityBuilder<AppAbility>(Ability as any)

  commonAbilities(can)
  if (role === 'ADMIN') {
    loginAbilities(can)
    userAbilities(can)
    clubAbilities(can)
    subAdminAbilities(can)
    adminAbilities(can)
  } else if (role === 'SUB_ADMIN') {
    loginAbilities(can)
    userAbilities(can)
    subAdminAbilities(can)
  } else if (role === 'USER' || role === 'CLUB') {
    loginAbilities(can)
    if (role === 'USER') {
      userAbilities(can)
    } else if (role === 'CLUB') {
      clubAbilities(can)
    }
  }
  return new Ability(rules) as AppAbility
}

export const ability = defineAbilityFor()

export const AbilityContext = createContext<AppAbility>(ability)
